import moment from 'moment-timezone';
import { FormAPI , ProcessAPI } from 'lecom-api';
import { toArray, mapValues, convertToString } from  'utils/object_utils';
import FormFieldTypes from 'form/constants/form_field_types';
import DocumentConstants from 'document/constants/document';
import { GridFormStore } from '../grid_form/reflux/grid_form_store';
import { formatDateToISO } from 'utils/date_utils_new.js';

export default class FormValuesSerializer {

	static serialize({ withGridFormValues = false, formId } = {}) {
		return {
			values: this.serializeBasicFormValues({ withGridFormValues, formId }),
			datagridCommands: this.serializeGrids(formId)
		};
	}

	static serializeBasicFormValues({ withGridFormValues = false, formId, formFields } = {}) {
        if(!formFields){
			formFields = withGridFormValues ? FormValuesSerializer.getFormFieldsWithGrid(formId) : FormValuesSerializer.getFormFields(formId);
		}

		let arrayFields = [];

        formFields
            .map((field) => {
				let value = this.serializeFieldValue(field);

				if (value) {
					if (Array.isArray(value)) {
						arrayFields.concat(value);
					} else {
						arrayFields.push(value);
					}
				}
			});

        return arrayFields;
    }

	static serializeFieldValue(field) {
		var value = this.parseFieldValue(field);

		if (value !== undefined && value !== 'undefined' || this.isDocumentFieldEmpty(field, value) && !field.hidden()) {
			return {
				id: field.id,
				value: value
			};
		}
	}

	static isDocumentFieldEmpty(field, value) {
		return field.component() === 'document' && value === DocumentConstants.EMPTY_VALUE;
	}

	static getFormFieldsWithGrid(formId) {
		return FormAPI.form(formId).allFields().filter(field => field.type() !== "LABEL" && field.type() !== "GRID");
	}

	static getFormFields(formId) {
		return FormAPI.form(formId).fields().filter(field => field.type !== "LABEL");
	}

	static parseFieldValue(field) {
		var value = field.value();

		if (field.type() === FormFieldTypes.DATE) {
			value = this.parseDateFieldValue(value);
		} else if (field.type() === FormFieldTypes.AUTOCOMPLETE || field.type() === FormFieldTypes.RADIO) {
			value = (value == null) ? value : String(value);
		}

		return value;
	}

	static parseDateFieldValue(value) {
		const dateFormatted = formatDateToISO(value);
		return dateFormatted;
	}

	static getIsMobile() {
		const processAPI = ProcessAPI.currentProcess();
		const isMobile = processAPI.isMobile();
		return isMobile;
	}

	static serializeGrids(formId) {
		var gridFormStoreState = GridFormStore.getState();
		var gridCommands = $.extend(true, {}, mapValues(gridFormStoreState, 'commands'));

		return Object.keys(gridCommands).map(gridName => {
			let command = gridCommands[gridName];
			let commandsGrid = gridFormStoreState[gridName];
			let commandsLength = commandsGrid._commands;

			for(var x=0; x < commandsLength.length; x++){
				let currentCommand = commandsLength[x];
				let dataRows = gridFormStoreState[gridName]._dataRows[x];
				// let dataRowsId = dataRows[x].id

				if(dataRows !== undefined){
					let type = typeof(dataRows.id);
					let typeId = type === "number";

					if(type === true && currentCommand['update'] && command[x] !== ['add']){
						commandsGrid._commands[x].id = dataRows.id;
						commandsGrid._commands[x]['update'].id = dataRows.id;
						command[x]['update'].id = dataRows.id;
						command[x].id = dataRows.id
					}
				}
			}
			return { [gridName]: this.serializeGridFormCommands(formId, command, gridName) };
		});
	}

	static serializeGridFormCommands(formId, commands, gridName) {
		commands = (commands || []);

		commands.forEach(command => this.commandHandler(formId, command, gridName));
		return commands;
	}

	static commandHandler(formId, command, gridName) {
		let fields = FormAPI.form(formId).get('fields');
		const gridDefinition = Object.keys(fields).map(field => fields[field]).find(field => field.id === gridName);
		const commandOperation = Object.keys(command)[0];

		if (commandOperation === 'add'){
			this.handleInsert(command, gridDefinition);
		}
		else if (commandOperation === 'update'){
			if(command['update'].values.id === undefined){
				command['update'].values.id = command['update'].id;
			}

			this.handleUpdate(command, gridDefinition);
		}
	}


	static handleInsert(command, gridDefinition) {
		delete command.add.values.id;
		this.handleValues(command.add.values, gridDefinition);
	}

	static handleUpdate(command, gridDefinition) {
		let id = command.update.values.id;
		// delete command.update.values.id;
		command.update.id = id;

		this.handleValues(command.update.values, gridDefinition);

	}

	static handleValues(values, gridDefinition) {
		this.removeValuesWithoutField(values, gridDefinition);
		this.changeValuesType(values, gridDefinition.fields);
	}

	static removeValuesWithoutField(values, gridDefinition) {
		Object.keys(values)
			.filter(fieldValueName => !gridDefinition.fields.find(field => field.name === fieldValueName))
			.forEach((keyValueWithoutField, index) => {
				this.removeValueWithoutField(values, keyValueWithoutField)});
	}

	static removeValueWithoutField(values, keyValueWithoutField) {
		delete values[keyValueWithoutField];
	}

	static changeValuesType(values, fieldsGrid) {
		Object.keys(values).forEach((key, index) => {
			const fieldGrid = fieldsGrid.find(field => field.name === key);
			this.changeValueType(values, key, fieldGrid.type);
		});
	}

	static changeValueType(values, key, typeFieldGrid) {
		const value = values[key];

		switch (typeFieldGrid) {
			case FormFieldTypes.DOCUMENT:
				values[key] = value === undefined ? DocumentConstants.EMPTY_VALUE : value;
				break;
			case FormFieldTypes.AUTOCOMPLETE:
				values[key] = convertToString(value);
				break;
			case FormFieldTypes.RADIO:
				values[key] = convertToString(value);
				break;
			case FormFieldTypes.CHECKBOX:
				values[key] = value === undefined ? null : String(value);
				break;
			case FormFieldTypes.DATE:
				values[key] = this.parseDateFieldValue(value);
				break;
			default:
				values[key] = value === undefined ? null : value;
				break;
		}
	}
}
